'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _helpers = require('helpers');

var _modal = require('redux/actions/modal');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  AddressInput: {
    displayName: 'AddressInput'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/usr/local/ibonus/src/components/AddressInput/AddressInput.jsx',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var AddressInput = _wrapComponent('AddressInput')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    lang: state.lang,
    currency: state.currency
  };
}, {
  showModal: _modal.showModal, hide: _modal.hide
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AddressInput, _Component);

  function AddressInput(props) {
    (0, _classCallCheck3.default)(this, AddressInput);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AddressInput.__proto__ || (0, _getPrototypeOf2.default)(AddressInput)).call(this, props));

    _this.openMapModal = function () {
      var _this$props = _this.props,
          label = _this$props.label,
          value = _this$props.value;


      _this.props.showModal({
        title: label,
        content: _react3.default.createElement('div', {
          id: 'g-map-in-modal',
          style: { width: '100%', height: '500px' }
        }),
        modalType: 'mapModal'
      });

      /** Если в инпуте уже есть введенный адрес */
      if (!!value && !!value.trim()) {
        _this._initGoogleMapFromAddress();
      } else {
        _this._initDefaultGoogleMap();
      }
    };

    _this._buildAddress = function (address) {
      var region = address.region;
      if (region) {
        if (['Москва', 'Санкт-Петербург, Севастополь']) {
          region = '';
        }
      }
      return (address.country ? address.country : '') + region + (address.city ? ', ' + address.city : '') + (address.street ? ', ' + address.street : '') + (address.building ? ', ' + address.building : '') + (address.chamber ? ', ' + address.chamber : '');
    };

    _this.onAddressSelect = function (selectedOption) {
      _this.setState({ selectedOption: selectedOption });
      var event = {
        target: {
          value: selectedOption.address || ''
        }
      };
      _this.props.onAddressChange(event);
    };

    _this._addConfirmationButton = function () {
      var lang = _this.props.lang;


      var parentDiv = document.createElement('div');
      parentDiv.style.marginBottom = '22px';
      _this._confirmationButton = new ConfirmationButton(parentDiv, lang);

      // Дефолтное состояние кнопки
      _this._confirmationButton.setIsEnabled(false);

      parentDiv.index = 1;
      _this.map.controls[window.google.maps.ControlPosition.BOTTOM_CENTER].push(parentDiv);
      parentDiv.addEventListener('click', function () {
        if (_this._confirmationButton.isEnabled) {
          var event = {
            target: {
              value: _this.address
            }
          };

          _this.props.onAddressChange(event);
          _this.props.hide();
        }
      });
    };

    _this._addWhereIamButton = function () {
      var lang = _this.props.lang;


      var parentDiv = document.createElement('div');
      _this._whereIamButton = new WhereIamButton(parentDiv, lang);

      parentDiv.index = 2;
      _this.map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(parentDiv);
      parentDiv.addEventListener('click', function () {
        if (navigator.geolocation) {
          try {
            navigator.geolocation.getCurrentPosition(function (position) {
              var latlng = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude);
              _this.mapMarker.setPosition(latlng);
              _this._geocodePosition(_this.mapMarker.getPosition());
              _this.map.setCenter(latlng);
            }, function (error) {
              _this._findUserGeolocation().then(function (response) {
                return response.json();
              }).then(function (response) {
                var latlng = new window.google.maps.LatLng(response.location.lat, response.location.lng);
                _this.mapMarker.setPosition(latlng);
                _this._geocodePosition(_this.mapMarker.getPosition());
                _this.map.setCenter(latlng);
              });
            });
          } catch (error) {
            if (_this.countErrorElementGmaps < 10) {
              _this.countErrorElementGmaps += 1;
              setTimeout(function () {
                _this._addWhereIamButton();
              }, 100);
            } else {
              _this._initDefaultGoogleMap();
            }
          }
        } else {
          _this._findUserGeolocation().then(function (response) {
            return response.json();
          }).then(function (response) {
            var latlng = new window.google.maps.LatLng(response.location.lat, response.location.lng);
            _this.mapMarker.setPosition(latlng);
            _this._geocodePosition(_this.mapMarker.getPosition());
            _this.map.setCenter(latlng);
          });
        }
        $('#you-location-img').addClass('_active');
      });
    };

    _this.geocoder = null;
    _this.infoWindow = null;
    _this.geolocation = null;
    _this.address = props.value;

    var selected = {};
    if (props.value) {
      //если есть сохраненный адрес
      selected = { address: props.value };
    } else {
      if (props.options) {
        _this.props.options.forEach(function (option) {
          if (option.is_default === true) {
            selected = option;
          }
        });
      }
    }
    _this.state = {
      selectedOption: selected
    };
    return _this;
  }

  (0, _createClass3.default)(AddressInput, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.geocoder = null;
      this.infoWindow = null;
      this.mapMarker = null;
      this.map = null;
    }
  }, {
    key: '_currentLangToGoogleLangCode',
    value: function _currentLangToGoogleLangCode(langSlug) {
      switch (langSlug) {
        case 'rus':
          return 'ru';
        case 'eng':
        case 'gbr':
        case 'eur':
          return 'en';
        case 'kaz':
          return 'kk';
        case 'ukr':
          return 'uk';
        default:
          return 'en';
      }
    }

    /**
     * Возвращает данные о местоположении по названию адреса
     * @returns {Promise<Response>}
     * @private
     */

  }, {
    key: '_findGeolocationByAddress',
    value: function _findGeolocationByAddress() {
      var _props = this.props,
          currency = _props.currency,
          value = _props.value;

      var lang = 'en';
      if (currency && !!currency.lang) {
        lang = this._currentLangToGoogleLangCode(currency.lang.slug);
      }
      /**
       * response : {
       *     address_components: (7) [{…}, {…}, {…}, {…}, {…}, {…}, {…}],
       *     types: ["premise", "street_address"],
       *     geometry:
       *       bounds: {northeast: {…}, southwest: {…}}
       *       location: {lat: 57.9966685, lng: 56.23020349999999}
       * }
       */
      return fetch('\n                https://maps.googleapis.com/maps/api/geocode/json?key=' + _config2.default.gapi.key + '\n                &address=' + encodeURIComponent(value) + '\n                &language=' + lang + '\n        ', {
        method: 'POST'
      });
    }

    /**
     * Поиск геолокации юзера
     * @returns {Promise<Response>}
     * @private
     */

  }, {
    key: '_findUserGeolocation',
    value: function _findUserGeolocation() {
      return fetch('https://www.googleapis.com/geolocation/v1/geolocate?key=' + _config2.default.gapi.key, {
        method: 'POST'
      });
    }
  }, {
    key: '_initDefaultGoogleMap',
    value: function _initDefaultGoogleMap() {
      var _this2 = this;

      if (!this.map) {
        try {
          this._findUserGeolocation().then(function (response) {
            return response.json();
          }).then(function (response) {
            var location = response.location;
            _this2.geolocation = location;
            _this2._createGoogleMap(location);
            _this2._initGeoCoder();
            _this2._initInfoWindow();
            _this2._addMapMarker(response);
            _this2._addConfirmationButton();
            _this2._addWhereIamButton();
            _this2._addSearchInput();
            _this2._addEventHandlers();
          });
        } catch (error) {
          if (this.countErrorElementGmaps < 10) {
            this.countErrorElementGmaps += 1;
            setTimeout(function () {
              _this2._initDefaultGoogleMap();
            }, 100);
          } else {
            throw error;
          }
        }
      } else {
        setTimeout(function () {
          _this2._getOldMapData();
          // this._addEventHandlers();
        }, 100);
      }
    }
  }, {
    key: '_initGoogleMapFromAddress',
    value: function _initGoogleMapFromAddress() {
      var _this3 = this;

      if (!this.map) {
        try {
          this._findGeolocationByAddress().then(function (response) {
            return response.json();
          }).then(function (response) {
            try {
              var result = response.results;
              if (result.length > 0) {
                _this3._createGoogleMap(result[0].geometry.location);
                _this3._initGeoCoder();
                _this3._initInfoWindow();
                _this3._addConfirmationButton();
                _this3._addWhereIamButton();
                _this3._createMapMarkerFromAddressLocation(response);
                _this3._addSearchInput();
                _this3._addEventHandlers();
              } else {
                _this3._initDefaultGoogleMap();
              }
            } catch (e) {
              throw e;
            }
          });
        } catch (error) {
          if (this.countErrorElementGmaps < 10) {
            this.countErrorElementGmaps += 1;
            setTimeout(function () {
              _this3._initGoogleMapFromAddress();
            }, 100);
          } else {
            this._initDefaultGoogleMap();
          }
        }
      } else {
        setTimeout(function () {
          _this3._getOldMapData();
          // this._addEventHandlers();
        }, 100);
      }
    }

    /**
     * создаем инстанс попапа
     * @private
     */

  }, {
    key: '_initInfoWindow',
    value: function _initInfoWindow() {
      this.infoWindow = new window.google.maps.InfoWindow();
    }
  }, {
    key: '_initGeoCoder',
    value: function _initGeoCoder() {
      this.geocoder = new window.google.maps.Geocoder();
    }
  }, {
    key: '_getOldMapData',
    value: function _getOldMapData() {
      var value = this.props.value;


      var oldMap = this.map;

      var oldMapState = {
        center: oldMap.center,
        bounds: oldMap.getBounds(),
        zoom: oldMap.zoom,
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: window.google.maps.MapTypeControlStyle.DROPDOWN_MENU
        }
      };

      var parentDivElement = document.getElementById('g-map-in-modal');

      this.map = new window.google.maps.Map(parentDivElement, oldMapState);

      /** Если в инпуте введен адрес - получаем из него метку на карте */
      if (!!value && value.trim().length > 0) {
        this._createMapMarkerFromAddress();
      } else {
        // Если мы зашли сюда и в инпуте нет адреса, значит уже был создан маркер с дефолтной позицией
        this._createDefaultMapMarker({
          lat: this.mapMarker.position.lat(),
          lng: this.mapMarker.position.lng()
        });
        this._addEventHandlers();
      }

      this._addSearchInput();
      this._addConfirmationButton();
      this._addWhereIamButton();
    }

    /**
     * @param location location { lat: 34, lng: 45 }
     * @private
     */

  }, {
    key: '_createGoogleMap',
    value: function _createGoogleMap(location) {
      var parentDivElement = document.getElementById('g-map-in-modal');
      this.map = new window.google.maps.Map(parentDivElement, {
        zoom: 10,
        center: location,
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: window.google.maps.MapTypeControlStyle.DROPDOWN_MENU
        }
      });
    }

    /**
     * После переключения языков, инпут с поиском куда-то пропадает (удаляется из дом-дерева),
     * поэтому каждый раз создаем новый инпут элемент для поиска
     * @private
     */

  }, {
    key: '_initSearchInputElement',
    value: function _initSearchInputElement() {
      var searchInputElement = document.createElement('input');
      searchInputElement.type = 'text';
      searchInputElement.id = 'pac-input';
      searchInputElement.className = 'controls';
      var modalMapParent = document.getElementById('g-map-in-modal');
      modalMapParent.appendChild(searchInputElement);
    }

    /**
     * Каждый раз, при создании нового инпута с поиском, в дом-дерево добавляется элемент с class=pac-container
     * И он отображается позади модалки
     * поэтому самостоятельно выставляем ему стили
     * @private
     */

  }, {
    key: '_initSearchResponseOutput',
    value: function _initSearchResponseOutput() {
      var searchResponseOutput = document.getElementsByClassName('pac-container');
      if (searchResponseOutput.length > 1) {
        searchResponseOutput[0].parentNode.removeChild(searchResponseOutput[0]);
      }
      if (searchResponseOutput[0]) {
        searchResponseOutput[0].style.cssText = 'z-index: 10000; width: 300px;';
      }
    }
  }, {
    key: '_addSearchInput',
    value: function _addSearchInput() {
      /**
       * Чтоб устранить баг, когда открывается полный экран и в нем нет инпута
       * поиска
       * https://stackoverflow.com/a/56712072
       */
      document.onfullscreenchange = function (event) {
        var target = event.target;
        var pacContainerElements = document.getElementsByClassName('pac-container');
        if (pacContainerElements.length > 0) {
          var pacContainer = document.getElementsByClassName('pac-container')[0];
          if (pacContainer.parentElement === target) {
            document.getElementsByTagName('body')[0].appendChild(pacContainer);
          } else {
            target.appendChild(pacContainer);
          }
        }
      };

      this._initSearchInputElement();
      // Create the search box and link it to the UI element.
      var input = document.getElementById('pac-input');
      // в _addEventHandlers навешаны два обработчика
      this.searchBox = new window.google.maps.places.SearchBox(input);
      this.map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);

      // для адекватного появления инпута в модалке
      setTimeout(function () {
        input.style.display = 'block';
      }, 500);
    }

    /**
     * Создание дефолтного маркера на карте по гео позиции юзера
     * @param location { lat: 34, lng: 45 }
     * @private
     */

  }, {
    key: '_createDefaultMapMarker',
    value: function _createDefaultMapMarker(location) {
      var lang = this.props.lang;

      this.mapMarker = new window.google.maps.Marker({
        map: this.map,
        draggable: true,
        position: location
      });

      // Попап над маркером
      this.infoWindow.open(this.map, this.mapMarker);
      // Дефолтный текст при первом открытии
      this.infoWindow.setContent(lang['createTradePoint.placemark.iconContent']);
    }

    /**
     *
     * @param response  - _findGeolocationByAddress описание ответа здесь
     * @private
     */

  }, {
    key: '_createMapMarkerFromAddressLocation',
    value: function _createMapMarkerFromAddressLocation(response) {
      this.mapMarker = new window.google.maps.Marker({
        map: this.map,
        draggable: true,
        position: response.results[0].geometry.location // { lat: 34, lng: 34 }
      });
      // Попап над маркером
      this.infoWindow.open(this.map, this.mapMarker);
      this._setGeolocationData([response.results[0]]);
    }
  }, {
    key: '_createMapMarkerFromAddress',
    value: function _createMapMarkerFromAddress() {
      var _this4 = this;

      this._findGeolocationByAddress().then(function (response) {
        return response.json();
      }).then(function (response) {
        if (response.results.length === 0) {
          _this4._createDefaultMapMarker(_this4.geolocation);
          _this4._addEventHandlers();
        } else {
          _this4.mapMarker = new window.google.maps.Marker({
            map: _this4.map,
            draggable: true,
            position: response.results[0].geometry.location // { lat: 34, lng: 34 }
          });
          // Попап над маркером
          _this4.infoWindow.open(_this4.map, _this4.mapMarker);
          _this4._setGeolocationData([response.results[0]]);
          _this4._addEventHandlers();
        }
      }).catch(function (error) {
        console.log('_createMapMarkerFromAddress catch err', error);
      });
    }

    /**
     * Добавление метки на карту
     * @param response
     * @private
     */

  }, {
    key: '_addMapMarker',
    value: function _addMapMarker(response) {
      var value = this.props.value;


      if (!!value && !!value.trim()) {
        this._createMapMarkerFromAddress(value);
      } else {
        this._createDefaultMapMarker(response.location);
      }
    }

    /**
     * Получение данных об конкретном месте на карте (адрес, страна и т.д.)
     * @param pos { lat: ƒ, lng: ƒ }
     * @private
     */

  }, {
    key: '_geocodePosition',
    value: function _geocodePosition(pos) {
      var _this5 = this;

      this.geocoder.geocode({
        latLng: pos
      }, function (results, status) {
        if (status === window.google.maps.GeocoderStatus.OK) {
          _this5._setGeolocationData(results);
        }
      });
    }

    /**
     * Добавляем обработчики событий на карту и маркер
     * @private
     */

  }, {
    key: '_addEventHandlers',
    value: function _addEventHandlers() {
      var _this6 = this;

      /** Обработка клика по карте */
      window.google.maps.event.addListener(this.map, 'click', function (event) {
        _this6.mapMarker.setPosition(new window.google.maps.LatLng(event.latLng.lat(), event.latLng.lng()));
        _this6._geocodePosition(_this6.mapMarker.getPosition());
        $('#you-location-img').removeClass('_active');
      });

      /** Когда перемещаем карту */
      window.google.maps.event.addListener(this.map, 'dragend', function () {
        $('#you-location-img').removeClass('_active');
      });

      if (this.mapMarker) {
        /** Когда тащим маркер */
        window.google.maps.event.addListener(this.mapMarker, 'drag', function (event) {
          _this6.mapMarker.setPosition(new window.google.maps.LatLng(event.latLng.lat(), event.latLng.lng()));
        });

        /** Когда тащим маркер */
        window.google.maps.event.addListener(this.mapMarker, 'dragend', function (event) {
          _this6._geocodePosition(_this6.mapMarker.getPosition());
          $('#you-location-img').removeClass('_active');
        });
      } else {
        setTimeout(function () {
          /** Когда тащим маркер */
          window.google.maps.event.addListener(_this6.mapMarker, 'drag', function (event) {
            _this6.mapMarker.setPosition(new window.google.maps.LatLng(event.latLng.lat(), event.latLng.lng()));
          });

          /** Когда тащим маркер */
          window.google.maps.event.addListener(_this6.mapMarker, 'dragend', function (event) {
            _this6._geocodePosition(_this6.mapMarker.getPosition());
            $('#you-location-img').removeClass('_active');
          });
        }, 300);
      }

      // Bias the SearchBox results towards current map's viewport.
      this.map.addListener('bounds_changed', function () {
        _this6._initSearchResponseOutput();
        _this6.searchBox.setBounds(_this6.map.getBounds());
      });

      this.searchBox.addListener('places_changed', function () {
        var places = _this6.searchBox.getPlaces();

        if (places.length === 0) {
          return;
        }
        if (!places[0].geometry) {
          return;
        }

        _this6.mapMarker.setPosition(new window.google.maps.LatLng(places[0].geometry.location.lat(), // число
        places[0].geometry.location.lng()) // число
        );
        _this6._geocodePosition(_this6.mapMarker.getPosition());
      });
    }

    /**
     * Заполняем модельки формы данными о полученном адресе
     * @param resultGeolocation
     * @private
     */

  }, {
    key: '_setGeolocationData',
    value: function _setGeolocationData(resultGeolocation) {
      var lang = this.props.lang;
      /** Если на карте нормальный адрес улицы, то можно получить нужные данные и показать кнопку сохранения */

      var addressData = resultGeolocation.find(function (item) {
        return item.types.includes('street_address') || item.types.includes('premise');
      });
      // Иногда может вернуться номер улицы без названия
      if (!!addressData && addressData.address_components.length > 6) {
        /** Получение адреса */
        var address = addressData.address_components;
        var currentCountry = address.find(function (item) {
          return item.types.includes('country');
        }).long_name;
        var region = address.find(function (item) {
          return item.types.includes('administrative_area_level_1') || item.types.includes('administrative_area_level_2') || item.types.includes('administrative_area_level_3') || item.types.includes('administrative_area_level_4') || item.types.includes('administrative_area_level_5');
        }).long_name;
        var city = address.find(function (item) {
          return item.types.includes('locality');
        }).long_name;
        var streetName = address.find(function (item) {
          return item.types.includes('route');
        }).long_name;
        var streetNumber = address.find(function (item) {
          return item.types.includes('street_number');
        }).long_name;

        /** Смена  контента попапа */
        this.infoWindow.setContent(streetName + ', ' + streetNumber);
        /** Делаем кнопку подтверждения активной */
        this._confirmationButton.setIsEnabled(true);

        var addressResult = {
          country: currentCountry,
          region: region,
          city: city,
          street: streetName,
          building: streetNumber,
          chamber: ''
        };
        this.address = this._buildAddress(addressResult);
        this.onAddressSelect({ address: this.address });
      } else {
        this._confirmationButton.setIsEnabled(false);
        this.infoWindow.setContent(lang['createTradePoint.placemark.iconContent']);
      }
    }

    /**
     * Собрать строку адреса {Регион}, {Город}, {Улица}, {Номер дома}, {Офис/квартира}
     * @param {Object} address
     * @returns {string}
     */


    /**
     * Добавление кнопки подтверждения на карту
     * @private
     */


    /**
     * Добавление кнопки "Где я?"
     * @private
     */

  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _props2 = this.props,
          placeholder = _props2.placeholder,
          label = _props2.label,
          buttonText = _props2.buttonText,
          options = _props2.options,
          _onAddressSave = _props2.onAddressSave,
          onAddAddress = _props2.onAddAddress,
          lang = _props2.lang,
          isOrderWasPaid = _props2.isOrderWasPaid;
      var selectedOption = this.state.selectedOption;


      var View = _helpers.ThemeHelper.getViewForComponent('AddressInput');

      return _react3.default.createElement(View, {
        isOrderWasPaid: isOrderWasPaid,
        placeholder: placeholder,
        value: selectedOption,
        options: options,
        label: label,
        buttonText: buttonText ? buttonText : lang['store.common.select_on_map'],
        buttonAddAddressText: lang['user.address.button.addNewAddress'],
        noOptionsMessageText: lang['user.address.noAddress'],
        onAddressChange: this.onAddressSelect,
        onAddAddress: onAddAddress,
        onAddressSave: function onAddressSave() {
          return _onAddressSave({ address: _this7.address });
        },
        buttonSaveText: lang['store.common.save_address'],
        onButtonClick: this.openMapModal
      });
    }
  }]);
  return AddressInput;
}(_react2.Component), _class2.propTypes = {
  isOrderWasPaid: _react2.PropTypes.bool,
  placeholder: _react2.PropTypes.string,
  value: _react2.PropTypes.string,
  options: _react2.PropTypes.array,
  label: _react2.PropTypes.string,
  buttonText: _react2.PropTypes.string,
  onAddressSave: _react2.PropTypes.func,
  onAddressChange: _react2.PropTypes.func.isRequired,
  onAddAddress: _react2.PropTypes.func.isRequired,
  lang: _react2.PropTypes.object.isRequired,
  currency: _react2.PropTypes.object.isRequired
}, _temp)) || _class));

exports.default = AddressInput;

/**
 * Кнопка подтверждения на карте
 * @param parentDiv html div
 * @param language
 * @constructor
 */

function ConfirmationButton(parentDiv, language) {
  var _this8 = this;

  this.isEnabled = false;
  var controlUI = document.createElement('div');
  parentDiv.appendChild(controlUI);

  // Текст
  var controlText = document.createElement('div');
  controlText.innerHTML = '\n                    <button\n                        class=\'le-button button_width_100\'\n                    >\n                        ' + language['createTradePoint.indicateOnMap.confirmationButton'] + '\n                    </button>';
  controlUI.appendChild(controlText);

  this.setIsEnabled = function (isEnabled) {
    _this8.isEnabled = isEnabled;
    // Пробовал через класс, но стили почему-то не применялись, поэтому пришлось сделать прямо
    if (isEnabled) {
      controlUI.setAttribute('disabled', 'false');
      controlUI.setAttribute('style', 'opacity: 1');
    } else {
      controlUI.setAttribute('style', 'opacity: .6');
      controlUI.setAttribute('disabled', 'true');
    }
  };
}

/**
 * Кнопка "Где я?" на карте
 * @param parentDiv html div
 * @param language
 * @constructor
 */
function WhereIamButton(parentDiv, language) {
  var firstChild = document.createElement('button');
  firstChild.id = 'whereiam-button';
  firstChild.className = 'map-whereiam-button';
  firstChild.title = language['createTradePoint.indicateOnMap.whereIamButton'];
  parentDiv.appendChild(firstChild);

  var secondChild = document.createElement('div');
  secondChild.id = 'you-location-img';
  firstChild.appendChild(secondChild);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AddressInput/AddressInput.jsx
// module id = 1595
// module chunks = 0